import { ClipboardList } from 'lucide-react'

import { Button } from '@/modules/shared/components/ui/button'
export type TButtonStartOrderComponent = {
  onStartOrder: () => void
}

export function ButtonStartOrderComponent({
  onStartOrder,
}: TButtonStartOrderComponent) {
  return (
    <Button
      className="fixed bottom-4 right-4 w-14 h-14 bg-green-500 rounded-full hover:bg-green-600"
      onClick={onStartOrder}
    >
      <ClipboardList size={24} />
    </Button>
  )
}
